import { makeGetCsv } from '../make-api'

const REPORT_ALL_APPLICATION = '/ReportAllApplication'

const reportAllApplicationApi = {
  getReportAllApplication: makeGetCsv(REPORT_ALL_APPLICATION),
}

export default reportAllApplicationApi
